import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { User, UserStorage } from '../user';
import { map, switchMap } from 'rxjs/operators';
import { UrlBuilder } from '../core';
import { UserPermissionsStorage } from '../user-permissions/user-permissions-storage';
import { UserPermissions } from '../user-permissions/user-permissions';
import { findEditedUserPk } from '../shared/route-helpers';

@Injectable()
export class UserSettingsAccessGuard implements CanActivate {
    private readonly currentUser$: Observable<User>;
    private readonly userPermissions$: Observable<UserPermissions>;

    constructor(userStorage: UserStorage, userPermissionStorage: UserPermissionsStorage, private readonly urlBuilder: UrlBuilder) {
        this.currentUser$ = userStorage.currentUser;
        this.userPermissions$ = userPermissionStorage.userPermissions;
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>  {
        return this.currentUser$.pipe(
            switchMap(user => {
                const editedUserPk = findEditedUserPk(route);

                if (user.metadata.userId === editedUserPk) {
                    return of(user.isSponsorOrInvestigator);
                }

                return this.userPermissions$.pipe(map(permissions => {
                    if (permissions.has('AccessUserProfile')) {
                        return true;
                    } else {
                        this.urlBuilder.esa().navigate();
                        return false;
                    }
                }));
            }));
    }
}